let view = null;

export default {
	namespace: 'single-news',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: SingleNewsView } = await import(
			/* webpackChunkName: "single-news-view" */ '../../templates/SingleNewsView'
		);
		view = new SingleNewsView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
